module.exports = __webpack_public_path__ + "img/kong_lam.cf45096b.jpg";